import React from "react";
import { Section } from "./styles";
import "dayjs/locale/pt-br";
import Calendar from "./components/Calendar";
import Cards from "./components/Cards";
import { Divider } from "antd";
import { PostProvider } from "./hooks/usePost";
import Guide from "./components/Guide";

const Post: React.FC = (): JSX.Element => {
  return (
    <PostProvider>
      <Section>
        <Calendar />
        <Divider />
        <Guide />
        <Cards />
      </Section>
    </PostProvider>
  );
};

export default Post;
